import { useEffect } from 'react'
import { Grid } from '@mui/material'

export const QRCode = ({ code }) => {
  useEffect(() => {
    const container = window.$('#qr-container')
    // El plugin agrega un <canvas>; si cambia el código hay que limpiar antes
    // o quedarían dos QR apilados.
    container.empty()
    container.qrcode({
      render: 'canvas',
      text: `${code}`,
      size: 225,
      minVersion: 1,
      maxVersion: 2,
      ecLevel: 'L',
      quiet: 0,
    })
  }, [code])

  return <Grid id="qr-container"></Grid>
}
